import React from 'react';
interface LogoProps {
  variant?: 'positive' | 'negative' | 'compact';
  className?: string;
}
export function Logo({
  variant = 'positive',
  className = ''
}: LogoProps) {
  const isNegative = variant === 'negative';
  const isCompact = variant === 'compact';
  const navyColor = isNegative ? '#FFFFFF' : '#1E293B';
  const cyanColor = '#2563EB';
  if (isCompact) {
    return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-44">
        <rect width="32" height="32" rx="8" fill={cyanColor} data-id="element-45" />
        {/* W Lettermark — straight angular */}
        <path d="M7 11L11 23L16 15L21 23L25 11" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-46" />
        {/* Chat Bubble */}
        <rect x="11.5" y="3" width="9" height="7" rx="2" stroke="#FFFFFF" strokeWidth="1.5" data-id="element-47" />
        <path d="M14 10L13 12.5L16 10" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-48" />
        {/* Exclamation */}
        <path d="M16 5.5V7.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" data-id="element-49" />
        <circle cx="16" cy="8.5" r="0.5" fill="#FFFFFF" data-id="element-50" />
      </svg>;
  }
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-51">
      <svg width="36" height="36" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-52">
        {/* W Lettermark — straight angular */}
        <path d="M8 18L15 38L24 26L33 38L40 18" stroke={navyColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-53" />
        {/* Chat Bubble */}
        <rect x="16" y="4" width="16" height="11" rx="3" stroke={navyColor} strokeWidth="2" data-id="element-54" />
        <path d="M21 15L19 19L25 15" stroke={navyColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-55" />
        {/* Exclamation */}
        <path d="M24 7.5V11" stroke={navyColor} strokeWidth="2" strokeLinecap="round" data-id="element-56" />
        <circle cx="24" cy="12.5" r="0.75" fill={navyColor} data-id="element-57" />
      </svg>

      <div className="flex flex-col justify-center leading-none" data-id="element-58">
        <div className="flex items-baseline" data-id="element-59">
          <span className="font-sans font-semibold text-xl tracking-tight" style={{
          color: navyColor
        }} data-id="element-60">
            Wi
          </span>
          <span className="font-sans font-semibold text-xl tracking-tight" style={{
          color: cyanColor
        }} data-id="element-61">
            Soft
          </span>
        </div>
        <span className="font-sans font-medium text-[10px] tracking-[0.15em] mt-1 opacity-70" style={{
        color: navyColor
      }} data-id="element-62">
          ALERTS
        </span>
      </div>
    </div>;
}